// import { LocationCity } from '@material-ui/icons';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { FaCity } from 'react-icons/fa';
import { RiArrowDropDownLine, RiArrowDropUpLine } from 'react-icons/ri';
import { Link } from 'react-router-dom';
import { history } from 'utils';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { plantInfo } from '../../../models';
import style from './sidebar.module.scss';
import { selectInverterItemSidebar, selectPlantItemSidebar, sidebarActions } from './sidebarSlice';
export interface MenuItemProps {
  menuItem: plantInfo;
}
export default function MenuItem({ menuItem }: MenuItemProps) {
  const [expand, setExpand] = useState<boolean>(false);
  const plantItemSelected = useAppSelector(selectPlantItemSidebar);
  const inverterItemSelected = useAppSelector(selectInverterItemSidebar);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (menuItem.id === plantItemSelected && inverterItemSelected !== null) {
      setExpand(true);
    }
  }, [inverterItemSelected, plantItemSelected, menuItem]);

  const handlePlantSidebarClick = (menuItem: plantInfo) => {
    localStorage.setItem('plantItemSidebar', menuItem.id);
    localStorage.setItem('inverterItemSidebar', '');
    localStorage.setItem('isValueNavInverter', '');
    dispatch(sidebarActions.setPlantItemSidebarList(menuItem.id));
    setExpand(true);
    history.push(navigationPlant(menuItem.id));
  };

  const handleInverterSidebarClick = (id: string) => {
    localStorage.setItem('inverterItemSidebar', id);
    localStorage.setItem('isValueNavPlant', '');
    dispatch(sidebarActions.setInverterItemSidebarList(id));
    history.push(navigationInverter(id));
  };

  const navigationPlant = (id: string): string => {
    switch (localStorage.getItem('isValueNavPlant')) {
      case '2':
        return `/plant/management/${id}`;
      case '3':
        return `/plant/maintenance/${id}`;
      case '4':
        return `/plant/alarm/${id}`;
      case '5':
        return `/plant/report/${id}`;
      default:
        localStorage.setItem('isValueNavPlant', '1');
        return `/plant/home/${id}`;
    }
  };
  const navigationInverter = (id: string): string => {
    switch (localStorage.getItem('isValueNavInverter')) {
      case '2':
        return `/inverter/alarm/${id}`;
      case '3':
        return `/Inverter/parameter/${id}`;
      default:
        localStorage.setItem('isValueNavInverter', '1');
        return `/inverter/home/${id}`;
    }
  };

  const handleIconUp = (e: any) => {
    e.stopPropagation();
    setExpand(false);
  };
  const handleIconDown = (e: any) => {
    e.stopPropagation();
    setExpand(true);
  };

  return (
    <div key={menuItem.id}>
      <div
        className={clsx(style.menuItemPlant, {
          [style.active]: plantItemSelected === menuItem.id && inverterItemSelected === null,
        })}
      >
        <div
          onClick={() => handlePlantSidebarClick(menuItem)}
          className={clsx(style.menuItem, {
            [style.active]: plantItemSelected === menuItem.id && inverterItemSelected === null,
          })}
        >
          <FaCity />
          <div className={style.menuItemLabel}>{menuItem.label}</div>
        </div>

        {menuItem.children.length > 0 && (
          <div
            className={clsx(style.iconButtonPlant, {
              [style.active]: plantItemSelected === menuItem.id && inverterItemSelected === null,
            })}
          >
            {expand ? (
              <RiArrowDropUpLine style={{ color: '#000' }} size={25} onClick={handleIconUp} />
            ) : (
              <RiArrowDropDownLine style={{ color: '#000' }} size={25} onClick={handleIconDown} />
            )}
          </div>
        )}
      </div>
      {/* </Link> */}
      {menuItem.children.length > 0 && (
        <ul
          className={clsx(style.hiddenInverter, {
            [style.showInverter]: expand,
          })}
        >
          {menuItem.children.map((menu) => (
            // <Link key={menu.id} to={`/inverter/home/${menu.id}`}>
            <div
              key={menu.id}
              onClick={() => handleInverterSidebarClick(menu.id)}
              className={clsx(style.menuItemInverter, {
                [style.active]: inverterItemSelected === menu.id,
              })}
            >
              <div className={style.menuIconInverter}></div>
              <span
                style={{
                  fontSize: '12px',
                  color: '#b84e4e',
                }}
              >
                {menu.code}{' '}
              </span>
              <span style={{ marginLeft: '8px' }}>{menu.label}</span>
            </div>
            // </Link>
          ))}
        </ul>
      )}
    </div>
  );
}
